<script setup lang="ts">
import type { SizeVariants } from '~kui/types/kui';

interface Props {
  trigger?: boolean;
  size?: Extract<SizeVariants, 'sm' | 'md'>;
  spotlightColor?: string;
}

const props = withDefaults(defineProps<Props>(), {
  spotlightColor: 'bg-secondary',
  trigger: false,
  size: 'md',
})

const spotlightRef = ref<HTMLElement | null>(null);
useSpotlightAnimation(spotlightRef, { trigger: toRef(props, 'trigger') });

const spotlightSizeClass = computed(() => props.size === 'sm' ? 'w-32' : 'w-50 lg:w-60');
</script>

<template>
  <div>
    <div
      ref="spotlightRef"
      class="fixed top-0 left-0 aspect-square blur-lg rounded-full pointer-events-none z-20 opacity-0"
      :class="[spotlightSizeClass, spotlightColor]"
    />
    <div class="relative">
      <slot />
    </div>
  </div>
</template>
